import type { StatusTone } from '@/features/registers/api';

/**
 * RL-1824 (gap #118): an integration's API status in plain words. The API says
 * `not_configured` until a provider's credentials are supplied.
 */
export function integrationStatus(status: string): {
  label: string;
  tone: StatusTone;
} {
  switch (status) {
    case 'not_configured':
      return { label: 'Not connected', tone: 'neutral' };
    case 'connected':
    case 'active':
    case 'healthy':
      return { label: 'Connected', tone: 'success' };
    case 'failed':
    case 'error':
      return { label: 'Not working', tone: 'danger' };
    default: {
      const words = status.replace(/_/g, ' ');
      return {
        label: words.charAt(0).toUpperCase() + words.slice(1),
        tone: 'warning',
      };
    }
  }
}
